<template>
<div>
<!--  End product image  -->
<!-- <aktiviteterBtn :title="aktiviteter[0].title" :text="aktiviteter[0].text" bildetittel="gutt.jpg"></aktiviteterBtn>
<aktiviteterBtn :title="aktiviteter[1].title" text="Aktivitetene som skjer på Tirsdag er" bildetittel="trafikklys.jpg"></aktiviteterBtn>
<aktiviteterBtn :title="aktiviteter[2].title" text="Aktivitetene som skjer på Onsdag er" bildetittel="sandkasse.jpg"></aktiviteterBtn>
<aktiviteterBtn :title="aktiviteter[3].title" text="Aktivitetene som skjer på Torsdag er" bildetittel="ski.jpg"></aktiviteterBtn>
<aktiviteterBtn :title="aktiviteter[4].title" :text="aktiviteter[4].text" bildetittel="trilleLov.jpg"></aktiviteterBtn> -->
<!-- <aktiviteterBtn :title="aktiviteter[5].title" text="Andre aktiviteter vi gjør i barnehagen" bildetittel="trafikklys.jpg"></aktiviteterBtn> -->

  <aktiviteterBtn
  v-for="aktivitet in aktiviteter" :key="aktivitet"
  :title="aktivitet.title"
  :text="aktivitet.text"
  :bildetittel="aktivitet.bilde"
  ></aktiviteterBtn>

    
    <!-- <div class="padding">
        <div id="container" v-on:click="info()" >
            <div class="product-image">
                <img alt="trafikklys" src="/img/trafikklys.jpg">
            </div>
            <div class="product-details-small">
              <h2>Aktiviteter mandag</h2>
              <p>hedkrlfkdfldns</p>
            </div>
        </div>
    </div> -->

<div style="paddingBottom: 10%;"></div>

</div>
</template>

<script>
import aktiviteterBtn from '../components/aktiviteterKnapp';

export default {
  data() {
    return {
      // bilde: require('../assets/aktiviteter/trafikklys.jpg'),
      url: require('../../public/img/trafikklys.jpg'),
      aktiviteter: [
        {title: 'Mandag', text: '', bilde: "gutt.jpg",},
        {title: 'Tirsdag', text: 'Tirsdager er vi i vålehallen. Her har vi da muligheten til å utvikle de motoriske ferdighetene våre. Barna kan være inne å løpe uansett hvordan været er ute. Vi er her sammen med Ole Brum familiebarnehage.', bilde: 'trafikklys.jpg'},
        {title: 'Onsdag', text: 'Onsdager er vi på tur i nærområdet. Vi er steder vi kan gå til som for eksempel Bibo, prestegården, Fjellborg, og lekeplassen. Vi er ofte på tur sammen med Ole Brum familiebarnehage.', bilde: 'trilleLov.jpg'},
        {title: 'Torsdag', text: 'hei2'+'haha', bilde: 'sandkasse.jpg'},
        {title: 'Fredag', text: 'Fredager er det ordensbarnet som bestemmer hva vi skal gjøre i samlingen. Barnet bestemmer hva vi skal gjøre og når vi skal gjøre de ulike tingene (med hjelp fra en voksen) Fredager har vi også en fredagsboks som barna ikke vet hva vi har oppi. Barna rister da på boksen for å finne ut hva som befinner seg i boksen, før de gjetter på hva den inneholder.', bilde: 'ski.jpg'},
      ]
    }
  },
  components: {
    aktiviteterBtn
  },
}
</script>


<style scoped>

/* fonts  */
/* @import url('https://fonts.googleapis.com/css?family=Abel|Aguafina+Script|Artifika|Athiti|Condiment|Dosis|Droid+Serif|Farsan|Gurajada|Josefin+Sans|Lato|Lora|Merriweather|Noto+Serif|Open+Sans+Condensed:300|Playfair+Display|Rasa|Sahitya|Share+Tech|Text+Me+One|Titillium+Web'); */

/* Web */
@media screen and (min-width: 1001px) {
  .padding {
    padding-top: 3%;
    padding-left: 5%;
    padding-right: 5%;
  }
#container{
	box-shadow: 0 15px 30px 1px rgba(128, 128, 128, 0.31);
	background: rgba(255, 255, 255, 0.90);
	text-align: center;
	border-radius: 5px;
	overflow: hidden;
	margin: auto;
  max-width: 100vh;
  width: auto;
  height: 28vh;
    
}
#container:hover{
    transform: scale(1.1, 1.1);
}

.product-details {
	position: relative;
	text-align: right;
  overflow: hidden;
	/* padding: 30px; */
	height: 100%;
	float: center;
  /* background-color: aqua; */
}
.product-details-small {
  position: relative;
	text-align: right;
  overflow: hidden;
	/* padding: 30px; */
	height: 100%;
  float: center;
  /* background-color: aqua; */
}
h1{
	/* font-family: 'Old Standard TT', serif; */
  text-align: center;
	font-size: 34px;
	color: #344055;
  margin: 0%;
  /* background-color: blue; */
}
h2{
	/* font-family: 'Old Standard TT', serif; */
  text-align: center;
	font-size: 34px;
	color: #344055;
  margin: 0%;
  padding: 1%;
  /* background-color: blue; */
}
p {
	/* font-family: 'Farsan', cursive; */
	text-align: center;
	font-size: 20px;
  color: #7d7d7d;
  /* background-color: black; */
}
}


/* Mobil */
@media screen and (max-width: 1000px) {
  .padding {
    padding-top: 3%;
    padding-left: 5%;
    padding-right: 5%;
  }
  #container{
  box-shadow: 0 15px 30px 1px rgba(128, 128, 128, 0.31);
	background: rgba(255, 255, 255, 0.90);
	text-align: center;
	border-radius: 5px;
	overflow: hidden;
  margin: auto;
  width: auto;
  height: 20vh;
  }

  .product-details {
	position: relative;
	text-align: right;
  overflow: hidden;
	/* padding: 30px; */
	height: 100%;
  /* float: left; */
  float: center;
  /* width: 50%; */
  /* width: 62.5%; */
  /* background-color: aqua; */
}
.product-details-small {
  position: relative;
	text-align: right;
  overflow: hidden;
	/* padding: 30px; */
	height: 100%;
  /* float: left; */
  float: center;
  /* width: 50%; */
  /* width: 66.5%; */
  /* background-color: aqua; */
}
h2{
  text-align: center;
	font-size: 25px;
	color: #344055;
  margin: 0%;
  padding: 1%;
  /* background-color: blue; */
}
p {
	/* font-family: 'Farsan', cursive; */
	text-align: center;
	font-size: 16px;
  color: #7d7d7d;
  /* background-color: black; */
}
}



/* 	Product Name */
/* h1{
	font-family: 'Old Standard TT', serif;
  text-align: center;
	font-size: 34px;
	color: #344055;
	margin: 0;
} */

/* The most important information about the product */
/* p {
	font-family: 'Farsan', cursive;
	text-align: center;
	font-size: 20px;
  color: #7d7d7d;
  background-color: black;
} */

/* control */

/* .control{
	position: absolute;
	bottom: 20%;
	left: 22.8%;
} */

/* product image  */
.product-image {
	/* transition: all 0.3s ease-out; */
	display: inline-block;
	position: relative;
	overflow: hidden;
	height: 100%;
    /* float: right; */
    float: left;
    width: auto;
    /* width: 100%; */
    display: inline-block;
    /* background-color: #344055; */
}

#container img {
    width: auto;
    height: 100%;
    }



</style>
